<template>
  <div class="flex items-center justify-center px-3 py-4">
    <a-dropdown
      :trigger="['click']"
      :overlayStyle="{ minWidth: '160px' }"
      placement="bottomRight"
    >
      <button
        :id="`external_domain_actions_${row?.id}`"
        class="more_actions_wrapper flex items-center justify-center"
        type="button"
        @click.stop
      >
        <ThemeImage :icon="imageNames.MORE_VERTICAL" alt="more actions" class="size-4" />
      </button>
      <template #overlay>
        <a-menu @click="onMenuClick">
          <a-menu-item
            :id="`external_domain_view_${row?.id}`"
            key="view"
          >
            {{ COPY.VIEW_DETAILS }}
          </a-menu-item>
          <a-menu-item
            :id="`external_domain_delete_${row?.id}`"
            key="delete"
            class="text-red-500"
          >
            {{ COPY.DELETE_CONFIRM }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script setup>
import { inject } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import { EXTERNAL_DOMAINS_COPY as COPY } from "@/src/constants/externalDomainsConstants.js";

const props = defineProps({
  value: { type: String, default: "" },
  row: { type: Object, default: () => ({}) },
});

const requestDeleteDomain = inject("requestDeleteDomain", () => {});
const requestViewDomain = inject("requestViewDomain", () => {});

const onMenuClick = ({ key }) => {
  if (key === "delete") {
    requestDeleteDomain(props.row);
  } else if (key === "view") {
    requestViewDomain(props.row);
  }
};
</script>
